<template>
  <div class="home">
    <div class="btn-logout" v-if="showLogout" @click="logout">退出</div>
    <div class="img-wrapper">
      <img
        src="../../assets/images/home/headImg.jpg"
        alt="活动背景"
        class="home-bg"
      />
      <div class="main-entrance" v-if="isShowMainEntrance" @click="openMain">
        <img
          class="icon"
          src="../../assets/images/home/home_main_entrance.png"
          alt=""
        />
      </div>
    </div>
    <!-- 报名页活动规则、写作要求 -->
    <TopButtons
      :activityInfo="activityAllInfo.activityInfo"
      :topicInfo="activityAllInfo.topicInfo"
      v-if="isDataReady"
    />
    <van-popup v-model="loginShow" class="x-van-popup">
      <xes-tal-login
        :loginData="loginData"
        @loginSuccess="loginSuccess"
        @regSuccess="regSuccess"
        @close="loginShow = false"
      />
    </van-popup>
    <share-poster
      ref="poster"
      :userName="activityAllInfo.personalArtical.name"
      :headImg="activityAllInfo.personalArtical.headicon"
      :type="posterType"
      :articleId="articleId"
    ></share-poster>
    <div class="home-content">
      <process
        :topicInfo="topicInfo"
        :personalArtical="personalArtical"
        :cityInfo="cityInfo"
        :isLogin="isLogin"
        :activityAllInfo="activityAllInfo"
        v-if="isDataReady"
      />
      <Tabs
        :personalArtical="personalArtical"
        :cityInfo="cityInfo"
        :isLogin="isLogin"
        :activityAllInfo="activityAllInfo"
        v-if="isDataReady"
      />
    </div>
    <!-- <img class="footer" src="../../assets/images/home/foot.png" alt=""> -->
    <WritingRequirement
      ref="writingRequirement"
      :topicInfo="activityAllInfo.topicInfo"
    />
  </div>
</template>

<script>
import { XesTalLogin } from '@xes/terra'
import Process from './components/process/index'
import Tabs from './components/tabs/index'
import TopButtons from './components/topButtons/index'
import { isApp } from '@/common/utils/xesFunction.js'
import eventBus from '@/summerCamp/utils/bus'
import area from '@/summerCamp/components/provincePicker/config/area'
import { mapMutations } from 'vuex'
import { SOURCEID } from '../../const'
import WritingRequirement from './components/common/writingRequirement'
import SharePoster from '@/summerCamp/components/sharePoster'

export default {
  name: 'home',
  components: {
    'xes-tal-login': XesTalLogin,
    Process,
    Tabs,
    TopButtons,
    WritingRequirement,
    SharePoster
  },
  data() {
    return {
      query: this.$route.query || {},
      isApp: isApp(),
      isLogin: false, // 是否有登录态
      loginShow: false, // 登录弹框出现
      checkShow: false, // 是否展示检测账号
      // loginCallback: '',
      loginData: {
        sGroupId: this.$config.sGroupId,
        source_id: ''
      }, // 登录所需参数
      activityInfo: {},
      topicInfo: {
        group_name: '',
        topic_list: []
      },
      areaNameArr: Object.keys(area),
      personalArtical: {},
      cityInfo: {
        defaultIndex: 0,
        id: 1,
        name: '北京' // 默认报名省份
      },
      activityAllInfo: {
        activityInfo: {},
        personalArtical: {},
        topicInfo: {},
        cityInfo: {
          defaultIndex: 0,
          id: 1,
          name: '北京' // 默认北京，如果报名是报名省份
        },
        isLogin: false
      },
      // 活动信息获取标识位
      isDataReady: false,
      lotteryUrl: 'https://activity.xueersi.com/advance/summerCampLottery/#/',
      posterType: 0,
      articleId: 0
    }
  },
  watch: {
    isLogin(val) {
      if (val) {
        console.log('watch')
        this.isLogin = val
      }
    }
  },
  computed: {
    // 夏令营抽奖活动跳转过来的才展示
    isShowMainEntrance() {
      return +this.query.to_summercamp === 1
    },
    showLogout() {
      return process.env.NODE_ENV !== 'production'
    }
  },
  async created() {
    this.init()
    this.$xesLogger.loadMsg({ clickid: '10.0.1', elemname: '页面访问' })
  },
  mounted() {
    eventBus.$on('index-btn-trigger', this.btnTrigger)
    eventBus.$on('show-writing-requirement', this.showWritingRequirement)
    eventBus.$on('share-poster', this.toSharePoster)
  },
  methods: {
    ...mapMutations.SET_USERID,
    logout() {
      location.href = 'https://login.xueersi.com/V1/Web/logout'
    },
    async init() {
      // this.loginCallback = this.initInvoke
      await this.checkLogin(false)
      // this.initInvoke()
      this.loginCallback()
    },
    btnTrigger({ from, fn }) {
      if (this.isLogin) {
        fn()
      } else {
        // 立即登录埋点
        if (from === 'signup') {
          this.$xesLogger.clickMsg({
            params: { clickid: '202', elemname: '点击登录' }
          })
        }
        // this.loginCallback()
        if (this.isApp) {
          this.appLogin(true, this.loginCallback)
        } else {
          this.loginShow = true
        }
      }
    },
    loginCallback() {
      // const final = {
      //   code: 0,
      //   stat: 1,
      //   msg: '请求成功',
      //   data: {
      //     activity_status: 5,
      //     apply_status: 1,
      //     artical_num: 0,
      //     course_link: 'http: //www.xueersi.com',
      //     period: [
      //       {
      //         id: 1,
      //         title: '第一期',
      //         start_date: '2021-05-2100: 00: 00',
      //         end_date: '2021-05-2900: 00: 00',
      //         status: 2
      //       },
      //       {
      //         id: 2,
      //         title: '第二期',
      //         start_date: '2021-05-3000: 00: 00',
      //         end_date: '2021-06-0623: 59: 59',
      //         status: 2
      //       },
      //       {
      //         id: 3,
      //         title: '第三期',
      //         start_date: '2021-06-0700: 00: 00',
      //         end_date: '2021-06-0723: 59: 59',
      //         status: 2
      //       },
      //       {
      //         id: 4,
      //         title: '第四期',
      //         start_date: '2021-06-0800: 00: 00',
      //         end_date: '2021-06-0823: 59: 59',
      //         status: 2
      //       },
      //       {
      //         id: 5,
      //         title: '第五期',
      //         start_date: '2021-06-0900: 00: 00',
      //         end_date: '2021-06-0923: 59: 59',
      //         status: 2
      //       },
      //       {
      //         id: 6,
      //         title: '第六期',
      //         start_date: '2021-06-1000: 00: 00',
      //         end_date: '2021-06-2723: 59: 59',
      //         status: 2
      //       },
      //       {
      //         id: 7,
      //         title: '第七期',
      //         start_date: '2021-06-2800: 00: 00',
      //         end_date: '2021-06-2923: 59: 59',
      //         status: 2
      //       },
      //       {
      //         id: 8,
      //         title: '第八期',
      //         start_date: '2021-06-3000: 00: 00',
      //         end_date: '2022-07-0123: 59: 59',
      //         status: 1
      //       }
      //     ],
      //     process_status: 0,
      //     submit_status: 0,
      //     top_image: 'https: //xesfile.xesimg.com/biz-growth-storage/operations/groupon/20210223/5c0fa7339563fa26d5754d15626261db.jpg'
      //   }
      // }
      if (this.isLogin) {
        Promise.all([
          this.getActivityInfo(),
          this.getPersonalArtical(),
          this.getArticalTopic()
        ]).then(([activityInfo, personalArtical, topicInfo]) => {
          this.activityAllInfo = {
            activityInfo,
            // activityInfo: final.data,
            personalArtical,
            topicInfo,
            cityInfo: this.cityInfo,
            isLogin: true
          }
          this.isDataReady = true
        })
      } else {
        Promise.all([this.getActivityInfo()]).then(([activityInfo]) => {
          this.activityAllInfo.activityInfo = activityInfo
          this.isDataReady = true
        })
      }
    },
    appLogin(isAutoLogin, next) {
      xesApp.appLoginBack = (result) => {
        if (+result === 1) {
          const isAndroid =
            navigator.userAgent.indexOf('Android') > -1 ||
            navigator.userAgent.indexOf('Adr') > -1
          next && next()
          if (isAndroid) {
            window.location.reload()
          }
        }
      }
      if (isAutoLogin) {
        xesApp.xesLogin('xesApp.appLoginBack')
      }
    },
    // 检测登陆态
    async checkLogin(isAutoLogin) {
      if (this.isLogin) {
        // this.loginCallback()
        return
      }
      await this.$api.checkLogin().then((res) => {
        if (res.code === 11025) {
          if (this.isApp) {
            this.appLogin(isAutoLogin)
          } else {
            if (isAutoLogin) {
              this.loginShow = true
            }
            this.isLogin = false
          }
        } else {
          this.isLogin = true
          this.setUserId(res.userId)
          // this.loginCallback()
        }
      })
      return this.isLogin
    },
    setUserId(userId) {
      this.$store.commit('SET_USERID', userId)
      this.$xesLogger.setCommonParam({
        userid: userId
      })
    },
    // 有登录态 - 切换账号
    changeLogin() {
      this.loginShow = true
    },
    // 新用户注册成功
    regSuccess(data) {
      this.setUserId((data.user_info && data.user_info.user_id) || '')
      this.loginShow = false
      this.isLogin = true
      if (this.loginCallback) {
        this.loginCallback()
      }
      this.$xesLogger.clickMsg({
        params: {
          clickid: 1.2,
          clicklevel: 1,
          action: 'regSucess',
          clickname: '网校新用户注册成功数'
        }
      })
    },
    // 老用户登录成功
    loginSuccess(data) {
      this.setUserId((data.user_info && data.user_info.user_id) || '')
      this.loginShow = false
      this.isLogin = true
      this.$xesLogger.clickMsg({
        params: {
          clickid: 1.1,
          clicklevel: 1,
          action: 'loginSucess',
          clickname: '网校老用户登录成功数'
        }
      })
      this.loginCallback()
    },
    async getActivityInfo() {
      const res = await this.$api.activityInfo()
      if (+res.code === 0 && res.data) {
        // this.activityInfo = res.data
      } else {
        this.$toast(res.msg || '获取活动信息失败')
      }
      // return this.activityInfo
      return res.data
    },
    // 获取命题信息
    async getArticalTopic() {
      const res = await this.$api.articalTopic()
      const data = res && res.data
      let topicInfo = {}
      if (+res.code === 0 && data && data.topic_list) {
        const { topic_list, group_name } = data
        // this.topicInfo = {
        //   group_name,
        //   topic_list
        // }
        topicInfo = {
          group_name,
          topic_list
        }
      }
      return topicInfo
    },
    // 跳转到抽奖
    openMain() {
      this.$xesLogger.clickMsg({
        params: { clickid: '10.0.2', elemname: '去主会场' }
      })
      setTimeout(() => {
        const { channelId = '' } = this.query
        window.location.href = `${this.lotteryUrl}?sourceId=${SOURCEID}&channelId=${channelId}`
      }, 300)
    },
    // 用户当前征文信息
    async getPersonalArtical() {
      const res = await this.$api.personalArtical()
      if (+res.code === 0 && res.data) {
        this.personalArtical = res.data
        this.articleId = this.personalArtical.artical_id
        const { province, province_id } = this.personalArtical
        if (province && province_id) {
          const defaultIndex = this.areaNameArr.indexOf(province)
          this.cityInfo.name = province
          this.cityInfo.id = province_id
          this.cityInfo.defaultIndex = defaultIndex
        }
      } else {
        // this.$toast(res.msg || '获取征文信息失败')
      }
      return res.data
    },
    showWritingRequirement() {
      this.$xesLogger.clickMsg({
        params: { clickid: '10.0.5', elemname: '点击写作要求' }
      })
      this.$refs.writingRequirement.visible = true
    },
    toSharePoster({ type, articleId }) {
      this.$xesLogger.clickMsg({
        params: { clickid: '52.0.0', elemname: '分享海报', type }
      })
      this.posterType = type
      // this.articleId = articleId
      this.$refs.poster.show()
    }
  },
  destroyed() {
    eventBus.$off('index-btn-trigger', this.btnTrigger)
    eventBus.$off('show-writing-requirement', this.showWritingRequirement)
    eventBus.$off('share-poster', this.toSharePoster)
  }
}
</script>
<style lang="less" scoped>
.btn-logout {
  position: relative;
  z-index: 10;
}

.home {
  width: 100%;
  min-height: 100vh;
  background: #ca0808;

  &-btn {
    position: relative;
    z-index: 11;
  }

  .img-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    width: 100%;

    .main-entrance {
      position: absolute;
      bottom: 226px;
      right: 3px;
      z-index: 10;

      .icon {
        width: 63px;
      }
    }
  }

  &-bg {
    width: 100%;
  }

  &-content {
    position: relative;
    z-index: 1;
    min-height: 60vh;
    margin-top: 85%;
  }
}
</style>
